'use client'

import { ColorCode, Icon } from '@vinted/web-ui'
import { ArrowRight16 } from '@vinted/monochrome-icons'
import classNames from 'classnames'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import {
  InfluencerLifestyleModel,
  InfluencerLifestyleCardModel,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { NewLifestyleSectionCard } from './NewLifestyleSectionCard'
import useSlider from '../../../../../hooks/useSlider'

type Props = { data: InfluencerLifestyleModel }

export const NewLifestyleSection = ({ data: { title, cards } }: Props) => {
  const {
    itemRefs,
    handleOnTouchStart,
    handleOnTouchMove,
    handleOnTouchEnd,
    goToNextItem,
    goToPreviousItem,
    wrapperDivRef,
    showButtons,
    currentCardIndex,
  } = useSlider({ childData: cards })
  const breakpoints = useBreakpoint()

  const renderButtonsGroup = (cardIndex: number) => {
    const previousButtonIsDisabled = cardIndex === 0
    const nextButtonIsDisabled = cardIndex === cards.length - 1

    return (
      <div className="influencer-v2__lifestyle-slider-buttons-container">
        <button
          type="button"
          className={classNames('influencer-v2__slider-wrapper-button influencer-v2__rotate-180', {
            disabled: previousButtonIsDisabled,
          })}
          onClick={goToPreviousItem}
          data-testid="slider-previous"
          disabled={previousButtonIsDisabled}
        >
          <Icon
            name={ArrowRight16}
            color={previousButtonIsDisabled ? ColorCode.GreyscaleLevel5 : ColorCode.GreyscaleLevel1}
          />
        </button>
        <button
          type="button"
          className={classNames('influencer-v2__slider-wrapper-button', {
            disabled: nextButtonIsDisabled,
          })}
          onClick={goToNextItem}
          data-testid="slider-next"
          disabled={nextButtonIsDisabled}
        >
          <Icon
            name={ArrowRight16}
            color={nextButtonIsDisabled ? ColorCode.GreyscaleLevel5 : ColorCode.GreyscaleLevel1}
          />
        </button>
      </div>
    )
  }

  const renderSlider = (data: Array<InfluencerLifestyleCardModel>) => {
    return (
      <div
        className="influencer-v2__slider-container-lifestyle"
        ref={wrapperDivRef}
        onTouchMove={handleOnTouchMove}
        onTouchStart={handleOnTouchStart}
        onTouchEnd={showButtons && breakpoints.wide ? undefined : handleOnTouchEnd}
      >
        {data.map((props, index) => (
          <div ref={itemRefs[index]} className="influencer-v2__slider-wrapper-item" key={index}>
            <NewLifestyleSectionCard key={index} {...props} index={index} />
          </div>
        ))}
      </div>
    )
  }

  return (
    <section data-testid="lifestyle-section" className="influencer-v2__lifestyle-section">
      <div className="influencer-v2__lifestyle-section-inner">
        <div className="influencer-v2__lifestyle-content">
          <h2 className="influencer-v2__lifestyle-title">{title}</h2>
          {showButtons && renderButtonsGroup(currentCardIndex)}
        </div>
        <div className="influencer-v2__lifestyle-cards-wrapper">{renderSlider(cards)}</div>
      </div>
    </section>
  )
}
